import { random } from 'lodash-es';

const showNewsletterSignup = () => random(1, 25) === 1;

export default showNewsletterSignup;
